import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionService } from '@unity/services/permission.service';
import { UnityEntitlementPath } from '@unity/utils/types';

@Directive({
  selector: '[unityAuthorize]',
  standalone: true,
})
export class AuthorizeDirective {
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly templateRef = inject(TemplateRef);
  private readonly permissionService = inject(PermissionService);
  private readonly $permissions = this.permissionService.$currentPermissions;

  public readonly $unityAuthorize = input.required<UnityEntitlementPath>({ alias: 'unityAuthorize' });
  public readonly $unityAuthorizeElse = input<TemplateRef<unknown>>(undefined, { alias: 'unityAuthorizeElse' });

  public constructor() {
    effect(() => {
      const authorizeClaim = this.$unityAuthorize();
      const elseRef = this.$unityAuthorizeElse();
      const permissions = this.$permissions();

      const isEntitled = permissions?.includes(authorizeClaim);
      const template = isEntitled ? this.templateRef : elseRef;

      this.viewContainerRef.clear();
      if (template) {
        this.viewContainerRef.createEmbeddedView(template);
      }
    });
  }
}
